import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { List } from 'immutable';
import { useState } from 'react';
import Raven from 'raven-js';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import AccountPicker from 'developer-experience-shared-components/accounts/components/AccountPicker';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import UILink from 'UIComponents/link/UILink';
import HR from 'UIComponents/elements/HR';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIFlex from 'UIComponents/layout/UIFlex';
import { search, changePage } from '../reducers/accounts';
import { noPortalFetchApplicationAuthorizationData } from '../actions/AppActions';
import { getAccounts, getAccountsPagination } from '../selectors/AccountSelectors';
import { getAuthorizationRequestInfo } from '../utils/urls';
import EnterpriseOnlyAlert from './EnterpriseOnlyAlert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FixedWidthTile = styled(UITile).withConfig({
  displayName: "ConnectAppInfo__FixedWidthTile",
  componentId: "x0xe5j-0"
})(["max-width:720px;"]);
const INCLUDED_APPS = {
  OKTA_SCIM_QA: 1204574,
  OKTA_SCIM_PROD: 233741
};
const ConnectAppInfo = ({
  providerDomain,
  providerName,
  providerId
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const accounts = useSelector(getAccounts);
  const accountsPagination = useSelector(getAccountsPagination);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const showEnterpriseWarning = [INCLUDED_APPS.OKTA_SCIM_QA, INCLUDED_APPS.OKTA_SCIM_PROD].includes(providerId);
  const selectAccount = account => {
    if (showEnterpriseWarning) {
      const authRequestInfo = getAuthorizationRequestInfo(location.search);
      setSelectedAccount(account);
      dispatch(noPortalFetchApplicationAuthorizationData({
        data: Object.assign({}, authRequestInfo, {
          hublet: account.hublet,
          hubId: account.get('id')
        })
      })).catch(e => Raven.captureException(e));
      return;
    }
    window.location.href = `${account.get('appDomain')}/oauth/${account.get('id')}/authorize${location.search}`;
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showEnterpriseWarning && /*#__PURE__*/_jsx(EnterpriseOnlyAlert, {
      location: location,
      providerName: providerName,
      selectedAccount: selectedAccount
    }), /*#__PURE__*/_jsx(FixedWidthTile, {
      className: "m-top-6 m-x-2",
      children: /*#__PURE__*/_jsxs(UITileSection, {
        children: [/*#__PURE__*/_jsx("span", {
          "data-test-id": "authorize-title",
          children: /*#__PURE__*/_jsxs(UIFlex, {
            align: "end",
            children: [/*#__PURE__*/_jsx("p", {
              className: "m-right-3 is--heading-2 m-bottom-0",
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(UITruncateString, {
                  matchContentWidth: true,
                  children: providerName
                })
              })
            }), /*#__PURE__*/_jsx("div", {
              style: {
                whiteSpace: 'nowrap'
              },
              children: providerDomain && /*#__PURE__*/_jsx(FormattedJSXMessage, {
                elements: {
                  Link: UILink
                },
                options: {
                  domain: providerDomain,
                  href: `https://${providerDomain}`
                },
                message: "oauth.authorization.appBy_jsx"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(AccountPicker, {
          accounts: List(accounts),
          accountsPagination: accountsPagination,
          changePage: page => dispatch(changePage(page)),
          search: searchString => dispatch(search(searchString)),
          selectAccount: selectAccount
        })]
      })
    })]
  });
};
export default ConnectAppInfo;